import React from 'react';

import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonList,
  IonRow,
} from '@ionic/react';
import { filterOutline } from 'ionicons/icons';

import Button from 'components/Button';
import { useSidePage } from 'components/Modal';
import Refresher from 'components/Refresher';
import {
  useScreenDispatch,
  useScreenState,
  withScreen,
} from 'components/Screen';
import TopToolbar from 'components/TopToolbar';
import { useQueryClient } from 'query';

import Chart from './components/Chart';
import DataTable from './components/DataTable';
import DataTableToolbar from './components/DataTableToolbar';
import FiltersModal from './components/FiltersModal';
import FiltersPrimary from './components/FiltersPrimary';
import Presets from './components/Presets';
import RelativeUploadedTime from './components/RelativeUploadedTime';
import { FILTERS, initialState } from './constants';
import { chart, grids } from './data/queryKeyFactory';
import screenReducer, { SET_FILTERS } from './screenReducer';

const PerformancePage: React.FC = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const queryClient = useQueryClient();

  const [openFilters] = useSidePage(FiltersModal);

  const handleOpenFiltersModal = () => {
    openFilters({
      initialValues: screenState.filters,
      defaultValues: initialState[FILTERS],
      onSubmit: (filters: any) => {
        dispatch({
          type: SET_FILTERS,
          payload: filters,
        });
      },
    });
  };
  const handleApplyPrimaryFilters = (filters: any) => {
    dispatch({
      type: SET_FILTERS,
      payload: filters,
    });
  };

  const handleRefresh = async () => {
    await Promise.all([
      queryClient.invalidateQueries(chart()),
      queryClient.invalidateQueries(grids),
    ]);
  };

  return (
    <>
      <IonHeader>
        <TopToolbar title={'Performance'}>
          <Button onClick={handleOpenFiltersModal}>
            <IonIcon slot={'icon-only'} icon={filterOutline} />
          </Button>
        </TopToolbar>
      </IonHeader>
      <IonContent>
        <Refresher onRefresh={handleRefresh} />
        <RelativeUploadedTime />
        <IonList lines={'full'} className={'primary-filters-container'}>
          <Presets />
          <FiltersPrimary
            initialValues={screenState.filters}
            onSubmit={handleApplyPrimaryFilters}
          />
        </IonList>
        <IonGrid className={'ion-no-padding'}>
          <IonRow>
            <IonCol>
              <Chart />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <DataTableToolbar />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <DataTable />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </>
  );
};

export default withScreen({
  screenReducer,
  initialState,
  name: 'PerformancePage',
})(React.memo(PerformancePage));
